import history from "utils/history";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import destructurePath from "@zendesk/knowledge-utils/lib/PageNavigator/destructurePath";

export const showNewRoute = (state = {}) => {
  history.push(`/new?brand_id=${getCurrentBrandId()}`, state);
};

export const setBrandId = () => {
  history.replace(
    `${history.location.pathname}?brand_id=${getCurrentBrandId()}`
  );
};

export const showIndex = (state = {}) => {
  history.push(`/?brand_id=${getCurrentBrandId()}`, state);
};

export const showEditRoute = ruleId => {
  history.push(`/edit/${ruleId}?brand_id=${getCurrentBrandId()}`);
};

export const showDuplicateRoute = ruleId => {
  history.push(`/duplicate/${ruleId}?brand_id=${getCurrentBrandId()}`);
};

export const getRoute = () => {
  const { route = "index" } = destructurePath(
    "/:route",
    history.location.pathname
  );

  return route;
};

export const getParams = () => {
  const route = getRoute();
  switch (route) {
    case "edit":
      const { id } = destructurePath("/edit/:id", history.location.pathname);
      return { id };
    case "duplicate":
      const params = destructurePath(
        "/duplicate/:id",
        history.location.pathname
      );
      return { id: params.id, isDuplicate: true };
    default:
      return {};
  }
};



// WEBPACK FOOTER //
// ./src/utils/navigation.js